exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav div a.router-link-active[data-v-09f64a84],nav div a[data-v-09f64a84]:active{border-bottom:4px solid #3b82f6;font-weight:600}", ""]);

// exports
